import { runInAction } from 'mobx';

import { ENDPOINTS } from '@/configs/endpoints';
import { ChartTipEntity, ChartTipSchema, ChartTipsResponseApi } from '@/entities/ChartTips';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { CollectionStore } from '@/stores/local/shared/CollectionStore';
import { MetaStore } from '@/stores/local/shared/MetaStore';
import call from '@/utils/api';
import { schemeParseMultiple } from '@/utils/schemeParse';

type ChartTipsStoreParams = {
  organizationId: number;
};

export class ChartTipsStore implements ILocalStore {
  readonly meta = new MetaStore();
  readonly collection = new CollectionStore<ChartTipEntity, ChartTipEntity>({
    parseItem: (data: ChartTipEntity) => data,
    getEntityKey: (data: ChartTipEntity) => String(data.id),
  });
  private readonly _organizationId: number;

  constructor({ organizationId }: ChartTipsStoreParams) {
    this._organizationId = organizationId;
  }

  fetchChartTips = async (): Promise<void> => {
    this.meta.setLoadedStartMeta();

    const response = await call<ChartTipsResponseApi>({
      endpoint: ENDPOINTS.chartSessions.getChartTips(this._organizationId.toString()),
    });

    if (response.isError) {
      this.meta.setLoadedErrorMeta();

      return;
    }

    runInAction(() => {
      const parsed = schemeParseMultiple(ChartTipSchema, response.data.items);

      this.collection.fromArray(parsed);
      this.meta.setLoadedSuccessMeta();
    });
  };

  destroy(): void {
    this.meta.destroy();
    this.collection.destroy();
  }
}
